export default function defaultRootComponent (defaultComponent) {
  return {
    props: {
      component: {
        type: [ String, Object ],
        default: defaultComponent
      }
    }
  }
}
